import * as types from './PhotographerUploadActionTypes';
import PhotographerUploadsApi from '../api/PhotographerUploadsApi';
import { IOrder, IOrderRowMetadata, IFailedOrder } from '../Entities';

function listPhotographerUploadsSuccess(orders: IOrder[]) {
    return { type: types.LIST_PHOTOGRAPHER_UPLOAD_SUCCESS, result: orders };
}

export function listPhotographerUploads() {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        PhotographerUploadsApi.listPhotographerUpload().then((result: IOrder[]) => {
            dispatch(listPhotographerUploadsSuccess(result));
        });
}

function savePhotographerUploadsMetadataSuccess(idList: number[]) {
    return {
        type: types.SAVE_PHOTOGRAPHER_UPLOAD_METADATA_SUCCESS,
        result: idList
    };
}

export function savePhotographerUploadsMetadata(metadataList: IOrderRowMetadata[]) {
    return (dispatch: (result: any) => void) =>
        PhotographerUploadsApi.saveMetaData(metadataList).then((idList: number[]) =>
            dispatch(savePhotographerUploadsMetadataSuccess(idList))
        );
}
